import { NewsAreaData } from "../component/News/data";
import { EventsDatas } from "../component/Event/data";

/** @param {typeof NewsAreaData} rows */
function newsToCms(rows) {
  return rows.map(({ img, heading, category, para }) => ({
    img: typeof img === "string" ? img : "",
    heading,
    category,
    para,
  }));
}

/** @param {typeof EventsDatas} rows */
function eventsToCms(rows) {
  return rows.map(({ heading, category, para }) => ({
    heading,
    category,
    para,
  }));
}

export function getDefaultSectionJson(sectionKey) {
  switch (sectionKey) {
    case "home_hero":
      return {
        h1Html:
          '<span><span class="color_big">Culture,</span> education,</span> &amp; integration — with sport at the heart',
        paragraphHtml:
          "PCF brings Pakistani families in Sweden together around heritage, learning, and building confidence in Swedish society. <strong>Badminton</strong> is our main sport; we also run swimming, cricket, and football at different times of year, plus social gatherings that strengthen community and integration.",
      };
    case "news_list":
      return newsToCms(NewsAreaData);
    case "events_list":
      return eventsToCms(EventsDatas);
    case "site_settings":
      return {
        contactEmail: "info@pcfsweden.se",
        phone: "+46 70 123 45 67",
        orgName: "PCF Sweden",
      };
    default:
      return {};
  }
}

export function defaultJsonString(sectionKey) {
  return JSON.stringify(getDefaultSectionJson(sectionKey), null, 2);
}
